import React from 'react'
import { connect } from 'react-redux'
import { DatePicker, Button, Checkbox,Carousel,Menu, Icon,Modal ,Tabs,Input,Alert,message} from 'antd'
const TabPane = Tabs.TabPane;
const confirm = Modal.confirm;
require('./rightBtn.scss')
require('../envelope/envelope.scss')
export default class RightBtn extends React.Component{
	constructor(props, context) {
        super(props, context);
        this.rightBtn=this.rightBtn.bind(this);
        this.handleBox_one=this.handleBox_one.bind(this);
        this.handleOk=this.handleOk.bind(this);
        this.handleSubmit=this.handleSubmit.bind(this);
        this.handleCancel=this.handleCancel.bind(this);
        this.handleCancel_two=this.handleCancel_two.bind(this);
        this.state={
            visible: false,
            handleBox_two:false,
            userName:'',
            userPhone:'',
            seversName:'5',
            industry:'14',
            tip:false,
            tipUser:false,
            optimization:false
        }
    }
    componentDidMount() {
        this.Get({url:'base/getQuote'}).then((res)=>{
            // 
            this.setState({getQuote:res.data.data})
        })
        this.setState({rightBtn: document.body.offsetHeight/2 -174})
        // console.log(this.props.data)
    }
    rightBtn(){
        // let data={visible:true}
        // this.props.callback(data)

        /////////-------//////
        this.setState({visible:true})
    }
    goConsulting(){
        this.setState({
          visible: true,
        });
    }
    handleOk(e) {
        // 需求提交
        this.Post({url:'base/putQuote',data:{phone:this.state.userPhone.toString(),name:this.state.userName,service:this.state.seversName,industry:this.state.industry,demand:this.state.demand},ContentType:'application/x-www-form-urlencoded'}).then((res)=>{
            // console.log(res)
        })
        // console.log(e);
        this.setState({
            visible: false,
        });
    }
    handleSubmit(e) {
        // 需求提交
        this.Post({url:'base/putQuote',data:{phone:this.state.userPhone.toString(),name:this.state.userName,service:this.state.seversName,industry:this.state.industry,demand:this.state.demand},ContentType:'application/x-www-form-urlencoded'}).then((res)=>{
            // console.log(res)
            // console.log(res.status==200)
            if (res.status==200) {
                message.success(<img src={require('../../assets/common/images/succeed.png')} alt=""/> ,2)
            }
            
        })
        this.setState({
            visible: false,handleBox_two:false
        });
    }
    handleCancel(e){
        //需求提交
        this.Post({url:'base/putQuote',data:{phone:this.state.userPhone,name:this.state.userName,service:this.state.seversName,industry:this.state.industryName,demand:this.state.demand},ContentType:'application/x-www-form-urlencoded'}).then((res)=>{
            // console.log(res)
        })
        // console.log(e);
        if (this.props.callBack) {
            this.props.callBack(false)
        }
        this.setState({
            visible: false,
        });
    }
    handleBox_one(){
        // console.log(this.state.handleBox_two)
        if (this.state.userPhone.toString().length!==11) {
            this.setState({tip:true})
        }else if (this.state.userName.toString().length<1) {
            this.setState({tipUser:true})
        }
        else {
            if (this.props.callBack) {
                this.props.callBack(false)
            }
            this.setState({handleBox_two:true,visible:false})
        }
        
    }
    handleBox_two(){
        this.setState({visible:false,handleBox_two:false})
    }
    handleCancel_two(){
        this.setState({visible:false,handleBox_two:false})
    }
    renderSevers(){
        if (this.state.getQuote.services) {
            return this.state.getQuote.services.map((item,index)=>(
                <TabPane tab={item.title} key={item.id}></TabPane>
            ))
        }else {
            return  <TabPane tab=" " key=' '></TabPane>
        }
        
    }
    renderIndustry(){
        if (this.state.getQuote.industry) {
            return this.state.getQuote.industry.map((item,index)=>(
                <TabPane tab={item.title} key={item.id}></TabPane>
            ))
        }else {
            return  <TabPane tab=" " key=' '></TabPane>
        }
    }
    seversCallback(key){
        // console.log(key);
        this.setState({seversName:key})
    }
    industryCallback(key){
        // console.log(key);
        this.setState({industry:key})
    }
	render(){
		let rightBtn= this.state.rightBtn;
        // console.log(this.props.data)

		return(
            <div>
                <div id="rightBtnBox" style={{height:'232px',position:'fixed',right:'0',top:rightBtn,zIndex:'99999999999',display:'flex',flexDirection:'column',justifyContent:'space-evenly',alignItems:'center'}}>
                    <div className="rightBtnIcon IconPhone"><img src={require('../../assets/common/images/dianhua2.png')} alt=""/>电话</div>
                    <div className="rightBtnIcon IconWechat"><img src={require('../../assets/common/images/weixinlianxi.png')} alt=""/> 微信</div>
                    {/* <div className="rightBtnIcon"><img src={require('../../assets/common/images/zaixiankefu.png')} alt=""/>在线客服 </div> */}
                    <div className="rightBtnIcon" onClick={this.rightBtn}><img src={require('../../assets/common/images/baojia.png')} alt=""/> 报价</div>
                </div>
                <Modal
                  title={null}
                  visible={this.props.data?this.props.data:this.state.visible}
                  onOk={this.handleOk}
                  onCancel={this.handleCancel}
                  bodyStyle={{position:'static',zIndex:'999999'}}
                  footer={null}
                  width={775}
                  maskClosable={false}
                >
                    <div className = "Bg">
                        <div className = "Title">
                            <p className = "Head">极速获取报价</p>
                            <p className = "Subhead">
                                产品经理将一对一为您服务，定制专属产品功能清单及相关报价。可拨打18281829555，直接咨询！
                            </p>
                            <img src = { require('../../assets/common/images/chatu.png') } alt=""/>
                        </div>
                        <div className = "Content">
                        
                            <p className = "P_Common" style={{paddingTop:'20px',marginBottom:'20px'}}>基础信息</p>
                            <div className = "Input">
                                <div className = "Pbox" style={{alignItems:'baseline'}}>
                                    <div>贵姓：</div>
                                    <div style={{width:'168.5px'}}>
                                        <Input style={{width:'100%'}} placeholder="请填写您的称呼" value={this.state.userName} autoFocus="autoFocus" onBlur={()=>this.state.userName.toString().length<1?this.setState({tipUser:true}):null} onChange={(e)=>{this.setState({userName:e.target.value,tipUser:false})}} />
                                        {this.state.tipUser?<p style={{width:'100%',fontSize:'10px',color:'red'}}>请输入您的称呼！</p>:null}
                                    </div>
                                </div>
                                <div className = "Pbox" style={{alignItems:'baseline'}}>
                                    <div>电话：</div>
                                    <div style={{width:'168.5px'}}>
                                        <Input style={{width:'100%'}} placeholder="请填写您的电话" value={this.state.userPhone} onBlur={()=>{this.state.userPhone.toString().length!==11?this.setState({tip:true}):null}} onChange={(e)=>{this.setState({userPhone:e.target.value,tip:false})}}/>
                                        {this.state.tip?<p style={{width:'100%',fontSize:'10px',color:'red'}}>手机号码输入错误!</p>:null}
                                    </div>
                                </div>
                            </div>
                            <p className = "P_Common" style={{paddingTop:'20px'}}>服务类型</p>
                            <div className = "Tabs">
                                {this.state.getQuote?
                                    <Tabs defaultActiveKey={this.state.seversName} onChange={this.seversCallback}>
                                        {this.renderSevers()}
                                    </Tabs>:null
                                }
                            </div>
                        </div>
                        <div className = "Btn" style={{cursor:'pointer',textAlign: 'center',lineHeight: '50px',color: 'white'}} onClick={this.handleBox_one}>
                            <img src = { require( '../../assets/common/images/xiayibu.png' ) } alt=""/>
                        </div>
                    </div>
                </Modal>
                <Modal
                  visible={this.state.handleBox_two}
                  onOk={this.handleBox_two}
                  onCancel={this.handleCancel_two}
                  bodyStyle={{position:'static',zIndex:'99999999999999'}}
                  footer={null}
                  width={775}
                  maskClosable={false}
                >
                    <div className = "Bg_tw">
                        <div className = "Title">
                            <p className = "Head">您的需求</p>
                            <p className = "Subhead">
                               根据您的需求填写，产品经理会在十分钟内联系您，为您提供专属方案及报价！
                            </p>
                            <img src = { require('../../assets/common/images/chatu.png') } alt=""/>
                        </div>
                        <div className = "Content">
                            <p className = "P_Common" style={{paddingTop:'20px'}}>所属行业：</p>
                            <div className = "Tab">
                                {this.state.getQuote?
                                    <Tabs defaultActiveKey={this.state.industry} onChange={this.industryCallback}>
                                        {this.renderIndustry()}
                                    </Tabs>:null
                                }
                            </div>
                            <p className = "P_Common" style={{paddingBottom:'20px'}}>请您简述需求：</p>
                            <div className  ="TextArea">
                                <textarea onChange={(e)=>{this.setState({demand:e.target.value})}} ></textarea>
                            </div>
                        </div>
                        
                        <div className = "Btn" onClick={this.handleSubmit} style={{cursor:'pointer',textAlign: 'center',lineHeight: '50px',color: 'white'}}>
                            <img src = { require( '../../assets/common/images/lijihuoqu.png' ) } alt=""/>
                        </div>
                    </div>
                </Modal>
            </div>
			
		)
	}
}
